var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-create',{attrs:{"open":_vm.open,"loading":_vm.loading,"title":_vm.title,"errorMessage":_vm.errorMessage},on:{"create":_vm.create,"close":function($event){return _vm.$emit('close')}}},[_c('interes-form',{ref:"form",attrs:{"input-errors":_vm.inputErrors},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }